import { render } from "./modal_declarationaib.vue?vue&type=template&id=50986eb8&scoped=true"
import script from "./modal_declarationaib.vue?vue&type=script&lang=js"
export * from "./modal_declarationaib.vue?vue&type=script&lang=js"

import "./modal_declarationaib.vue?vue&type=style&index=0&id=50986eb8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50986eb8"]])

export default __exports__